<script>
import ArticleMeaningAntonym from "./meanings/ArticleMeaningAntonym.vue";
import ArticleMeaningCompositions from "./meanings/ArticleMeaningCompositions.vue";
import ArticleMeaningExample from "./meanings/ArticleMeaningExample.vue";
import ArticleMeaningSynonym from "./meanings/ArticleMeaningSynonym.vue";
import ArticleMeaningWordConnections from "./meanings/ArticleMeaningWordConnections.vue";

export default {
  name: "ArticleMeanings",
  components: {
    ArticleMeaningAntonym,
    ArticleMeaningCompositions,
    ArticleMeaningExample,
    ArticleMeaningSynonym,
    ArticleMeaningWordConnections
  },
  props: {
    meanings: {
      type: Array,
      required: true
    }
  },
  methods: {
    isDot(bnr) {
      return bnr.includes("#") || bnr.includes("&");
    }
  }
};
</script>

<template>
  <div class="indentation-container">
    <div v-for="(meaning, meaningIndex) in meanings" :key="meaningIndex">
      <div
        v-if="meaning.bnr && !isDot(meaning.bnr)"
        :class="{ 'indentation-container': !isDot(meaning.bnr) }"
      >
        <div
          class="article-list-bullet article-list-bullet--primary article-list-bullet--prominent"
          v-html="meaning.bnr"
        ></div>
      </div>
      <div class="indentation-container">
        <ArticleMeaningWordConnections
          :definitions="meaning.definition"
          :definition-extensions="meaning.definitionExtension"
          :show-header="isDot(meaning.bnr)"
          :sublemma-one="meaning.sublemmaOne"
          :sublemma-number="meaning.sublemmaNumber"
          :r-comment="meaning.rComment"
          :f-comment="meaning.fComment"
        ></ArticleMeaningWordConnections>
        <ArticleMeaningSynonym :synonym="meaning.synonym"></ArticleMeaningSynonym>
        <ArticleMeaningAntonym :antonym="meaning.antonym"></ArticleMeaningAntonym>
        <ArticleMeaningExample :example="meaning.example"></ArticleMeaningExample>
        <ArticleMeaningCompositions
          :sublemmas-two-sms-one="meaning.sublemmaTwoSmsOne"
          :sublemmas-two-sms-two="meaning.sublemmaTwoSmsTwo"
        ></ArticleMeaningCompositions>
      </div>
      <div class="article-content__spacer"></div>
    </div>
  </div>
</template>
